"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientInfo = void 0;
const uuid_1 = require("uuid");
const constants_1 = require("../constants");
const cache_1 = require("./cache");
const get_date_string_1 = __importDefault(require("./get-date-string"));
const getCachedClientInfo = () => {
    const clientCache = localStorage.getItem(constants_1.CLIENT_CACHE_KEY);
    if (clientCache) {
        try {
            return JSON.parse(clientCache);
        }
        catch (e) {
            // do nothing
        }
    }
    return null;
};
exports.getClientInfo = (instance) => {
    if (instance.deviceId || !instance.clientUserAgent) {
        return {
            clientId: null,
            clientCreated: null,
        };
    }
    if (!cache_1.supportsLocalStorage()) {
        throw new Error('Local storage is not supported. Cannot create client id');
    }
    const cachedClientObj = getCachedClientInfo();
    if (cachedClientObj && cachedClientObj.clientId && cachedClientObj.clientCreated) {
        return {
            clientId: cachedClientObj.clientId,
            clientCreated: cachedClientObj.clientCreated,
        };
    }
    const newClientInfo = {
        clientId: uuid_1.v4(),
        clientCreated: get_date_string_1.default(),
    };
    localStorage.setItem(constants_1.CLIENT_CACHE_KEY, JSON.stringify(newClientInfo));
    return newClientInfo;
};
exports.default = exports.getClientInfo;
